<script setup lang="ts">
import type { MenuItem } from '@convatec/180medical-website/types/navigation'

const { group, closeMenu } = defineProps<{
  group: MenuItem
  closeMenu: () => void
}>()
</script>

<template>
  <div
    :key="group.title"
    class="group relative transitions-extra-slow"
  >
    <div class="mega-column__heading">
      <p
        class="font-semibold"
        no-prefetch
      >
        {{ group.title }}
      </p>
      <p class="mt-1">
        {{ group.description }}
      </p>
    </div>
    <ul class="mega-column__nav-list">
      <li
        v-for="sub in group.children"
        :key="sub.title"
      >
        <ULink
          v-if="sub.url"
          :to="useCmsUrl(sub.url)"
          :locale="false"
          class="underline"
          no-prefetch
          @click="closeMenu()"
        >
          {{ sub.title }}
        </ULink>
        <p class="mt-1">
          {{ sub.description }}
        </p>
      </li>
    </ul>
  </div>
</template>
